import React from 'react';
import { FormattedMessage } from '@/components/ui/formatted-message';
import { HelpCircle } from 'lucide-react';

interface Message {
  id: string;
  content: string;
  is_user: boolean;
  created_at: string;
  kind?: "CHAT" | "ARTF" | "QUESTION" | "ANSWER" | "EDIT";
  model?: string;
  tokens?: number;
  is_edited?: boolean;
  is_regenerated?: boolean;
  retrieval_latency_ms?: number;
  model_latency_ms?: number;
  retrieval_hit_count?: number;
  parent_message_id?: string;
  client_message_id?: string | null;
}

interface QuestionMessageProps {
  message: Message;
}

export const QuestionMessage: React.FC<QuestionMessageProps> = ({ message }) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-sm font-semibold text-primary">
        <HelpCircle className="h-4 w-4" />
        <span>Clarification Questions</span>
      </div>
      <div className="rounded-lg border border-primary/20 bg-primary/5 p-4">
        <div className="text-[15px] leading-7 text-foreground">
          <FormattedMessage content={message.content} />
        </div>
      </div>
      <p className="text-xs text-muted-foreground italic">
        Please answer these questions to help create a better artifact.
      </p>
    </div>
  );
};
